import { Injectable } from '@angular/core'

@Injectable()
export class PdfService {
  constructor() {}

  getPDF(): string {
    return 'https://apidev.cpm.set/api/pdf/marcroData'
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/service/pdf.service.ts